export default __webpack_public_path__ + "static/media/SEGOEUII.1ccb0698.TTF";